import React from 'react'
import * as SC from './styled'
import Button from 'components/common/Button'
import InputComponent from 'components/common/Input'
import { ReactSVG } from 'react-svg'

const Search = ({ onChange, clearInput, onSearch, value }) => {
  return (
    <SC.SearchWrapper>
      <SC.InputWrapper>
        <InputComponent
          placeholder={'Искать артиста'}
          onChange={onChange}
          value={value}
          clearInput={clearInput}
          prefixIcon={<ReactSVG src={'svgs/searchIcon.svg'}/>}
        />
      </SC.InputWrapper>
      <SC.ButtonWrapper>
        <Button children={'Искать'} onClick={onSearch} />
      </SC.ButtonWrapper>
    </SC.SearchWrapper>
  )
}

export default Search
